import dayjs from 'dayjs'
/**
 * 返回需要的日期格式
 * @param {String/Date} date 日期
 * @param {String} formatStr 格式
 * @returns 需要的日期格式
 */
export function formatDate (date, formatStr = 'YYYY/MM/DD HH:mm') {
  return dayjs(date).format(formatStr)
}